<template>
  <v-card v-if="driver">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Other Details") }}</h3>
    </v-btn>
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-text-field
          :label="$i18n.t('Aadhar No.')"
          v-model="driver.driverDetail.aadhar"
          maxlength="100"
        />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-text-field
          :label="$i18n.t('PAN Card No.')"
          v-model="driver.driverDetail.pan"
          maxlength="100"
        />
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-text-field
          :label="$i18n.t('Experience')"
          v-model="driver.driverDetail.fields.experience"
          type="number"
          maxlength="5"
        />
      </v-col>
      <v-col cols="12" sm="12" md="9" lg="9">
        <z-language-select multiple v-model="driver.languages" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "Other",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Other extends Vue {
  driver = null;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.driver = newVal;
  }

  async mounted() {
    if (this.value) this.driver = this.value;

    if (!this.driver) this.driver = {};
    if (!this.driver.driverDetail) this.driver.driverDetail = {};
    if (!this.driver.driverDetail.fields) this.driver.driverDetail.fields = {};
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>